/**
 * @desc 删除
 */
const URL = "/rantion-mns";
import http, { updateResponse } from "@/http";
export function request(params: API.mns.messageNamespace.remove.Params, options?: any) {
  return updateResponse(
    http(URL + `/messageNamespace/delete`, {
      method: "DELETE",
      params,

      ...options,
    }),
  );
}
